import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-infra',
  templateUrl: './infra.component.html',
  styleUrls: ['./infra.component.scss']
})
export class InfraComponent implements OnInit {
  imgUrl:string[]=[
    // '/assets/img/campus/infra/11.jpg',
    // '/assets/img/campus/infra/12.jpg',
    // '/assets/img/campus/infra/1.jpg',
    // '/assets/img/campus/infra/2.jpg',
    // '/assets/img/campus/infra/3.jpg',
    // '/assets/img/campus/infra/4.jpg',
    // '/assets/img/campus/infra/5.jpg',
    // '/assets/img/campus/infra/6.jpg',
    // '/assets/img/campus/infra/7.jpg',
    // '/assets/img/campus/infra/8.jpg',
    // '/assets/img/campus/infra/9.jpg',
    // '/assets/img/campus/infra/10.jpg',
    '/assets/img/campus/infra/13.jpg',
    // '/assets/img/campus/infra/14.jpg',
    // '/assets/img/campus/infra/15.jpg',
    // '/assets/img/campus/infra/16.jpg',
    '/assets/img/campus/infra/17.jpg',
    '/assets/img/campus/infra/18.jpg',
  ];
  infra:{name:string,count:string}[]=[
    {name:'Class Rooms',count:''},
    {name:'Principal Office',count:''},
    {name:'Science Labs (PCMB)',count:''},
    {name:'Mathematics lab',count:'1'},
    {name:'Kindergarten Play Room',count:'1'},
    {name:'Self Management Lab',count:'1'},
    {name:'First Aid Room',count:'1'},
    {name:'Indoor Games Facility ( Table Tennis, Dots, Carom, Chess)',count:''},
    {name:'Playground - Cricket, Football, Volleyball, Basketball, Kho-Kho, Running Track, Badminton, Handball',count:''},
    {name:'Yoga Room',count:''},
    {name:'Computer Labs',count:'2'},
    {name:'Music Rooms',count:'3'},
    {name:'Art Rooms',count:'2'},
    {name:'School Libraries',count:'1'},
    {name:'Staff Rooms',count:'5'},
    {name:'Exam Cell',count:'1'},
    {name:'School Office',count:'1'},
    {name:'Games / Sports Room',count:'1'},
    {name:'Multimedia Hall/ Auditorium',count:'1'},
    {name:'Play Room',count:'1'},
    {name:'Composite Lab',count:'1'},
    {name:'Pantry',count:'1'},

    
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
